<template>
  <ul class="footer-links">
    <li v-for="(item, idx) in links" :key="idx">
      <a
        :href="item.link"
        :title="item.title"
        :rel="item.newTab ? 'noopener' : null"
        :target="item.newTab ? '_blank' : null"
        >{{ item.title }}</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    links: Array,
  },
};
</script>

<style lang="scss" scoped>
.footer-links {
  @media (max-width: $screen-xs-max) {
    margin-bottom: 16px;
    padding-left: 8px;
  }

  list-style: none;
  margin: 0;
  padding: 0;

  > li {
    > a {
      color: lighten($blue-light, 40%);
      display: inline-block;
      padding: 2px 0;

      &:hover,
      &:focus {
        color: $blue-light;
      }
    }
  }
}
</style>
